import React from 'react';
import PropTypes from 'prop-types';
import RecipeCollectionCard from './recipe_collection_card';
import {
  useGetDistilledMealsByParentQuery,
  useGetSharedBoardQuery,
  useGetDistilledSharedMealsByParentQuery,
  useGetSmorgBoardQuery,
} from '../../app/smorgAppSyncGraphQLApi';
import { SHARED_BOARDS_REFRESH_INTERVAL_SECONDS } from '../../services/end_user_published_resources';

const RecipeCollectionItem = ({
  boardID,
  title,
  firstMealID,
  onClickBoard,
  isFavourite,
  isSharedBoard,
}) => {
  const { data: smorgBoard } = useGetSmorgBoardQuery(boardID, {
    skip: !boardID || isSharedBoard,
  });

  const { data: sharedBoard } = useGetSharedBoardQuery(boardID, {
    skip: !boardID || !isSharedBoard,
    refetchOnMountOrArgChange: SHARED_BOARDS_REFRESH_INTERVAL_SECONDS,
  });

  const { data: distilledMeals } = useGetDistilledMealsByParentQuery(boardID, {
    skip: !boardID || isSharedBoard,
  });

  const { data: distilledSharedMeals } =
    useGetDistilledSharedMealsByParentQuery(boardID, {
      skip: !boardID || !isSharedBoard,
    });

  let boardCoverImageUrl = (smorgBoard || sharedBoard)?.coverImageUrl;
  if (!boardCoverImageUrl && firstMealID) {
    boardCoverImageUrl = ((
      (distilledMeals || {})[firstMealID] ||
      (distilledSharedMeals || {})[firstMealID]
    )?.recipes || [])[0]?.imageUrl;
  }

  return (
    <RecipeCollectionCard
      boardID={boardID}
      title={title}
      coverImageUrl={boardCoverImageUrl}
      onClickBoard={onClickBoard}
      isFavourite={isFavourite}
    />
  );
};

RecipeCollectionItem.propTypes = {
  boardID: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  firstMealID: PropTypes.string,
  onClickBoard: PropTypes.func.isRequired,
  isFavourite: PropTypes.bool.isRequired,
  isSharedBoard: PropTypes.bool.isRequired,
};

RecipeCollectionItem.defaultProps = {
  firstMealID: null,
};

export default RecipeCollectionItem;
